import React from 'react';
import useWidget from '@Utils/core/useWidget';
import { WidgetId } from '@Utils/edge/constants';
import * as Styled from './DownloadButtonMobile.styled';
import useDefineDevice from '@Utils/core/hooks/useDefineDevice';

interface OwnProps {
  appStoreUrl: string;
  googlePlayUrl: string;
}

const DownloadButtonMobile: ReactFCWithChildren<OwnProps> = (props) => {
  const globalStatic = useWidget(WidgetId.GlobalStaticV3);
  const { isAndroidDevice, isIosDevice, isMobileDevice } = useDefineDevice();

  const appleStoreLogo = React.useMemo(
    () => globalStatic.images.appleStoreLogo,
    [globalStatic.images.appleStoreLogo],
  );
  const googlePlayLogo = React.useMemo(
    () => globalStatic.images.googlePlayLogo,
    [globalStatic.images.googlePlayLogo],
  );

  if (!isMobileDevice) {
    return null;
  }

  return (
    <Styled.Wrapper>
      {isAndroidDevice && (
        <Styled.StoreLink href={props.googlePlayUrl}>
          <Styled.Store src={googlePlayLogo.src} alt={googlePlayLogo.alt} />
        </Styled.StoreLink>
      )}
      {isIosDevice && (
        <Styled.StoreLink href={props.appStoreUrl}>
          <Styled.Store src={appleStoreLogo.src} alt={appleStoreLogo.alt} />
        </Styled.StoreLink>
      )}
    </Styled.Wrapper>
  );
};

export default DownloadButtonMobile;
